<template>
  <div>
    <v-dialog
      v-model="approveDialog"
      persistent
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-text class="px-4">
          <v-layout
            row
            wrap
          >
            <v-flex xs12>
              <div class="branch-description py-3">
                {{ $t('common.areYouSure') }}
              </div>
            </v-flex>
            <!-- <v-flex xs12>
              <v-alert
                type="error"
                :value="inValid"
              >
                Please select Deliver Branch
              </v-alert>
            </v-flex>

            <v-flex xs12>
              <div class="branch-description py-3">
                In which Branch you want to receive this order?
              </div>
            </v-flex>

            <v-flex xs12>
              <v-select
                :items="branchesList"
                v-model="formData.deliver_branch_id_fk"
                autocomplete
                :label="$t('customer.deliverBranchLabel')"
              />
            </v-flex> -->
          </v-layout>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            style="height:auto"
            @click="closeDialog()"
            outline
            color="normal"
          >{{ $t('common.cancel') }}</v-btn>

          <v-btn
            style="height:auto" class="rtl-mr-4pct"
            outline
            color="success"
            @click="save()"
          >{{ $t('common.save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'

export default {
  props: {
    approveDialog: { type: Boolean, default: false },
    orderId: { type: Number, required: true }
  },

  data() {
    return {
      branchesList: [],
      formData: {},
      inValid: false
    }
  },

  mounted() {
    this.getBranchesList()
    this.getLoggedInUser()
  },

  methods: {
    getLoggedInUser() {
      this.authUser = JSON.parse(localStorage.getItem('user_data'))
      // this.formData.deliver_branch_id_fk = this.authUser.default_branch_id_fk
    },

    getBranchesList() {
      this.branchesList = []

      let token = localStorage.getItem('access_token')
      axios
        .get('api/branch/list', { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          response.data.forEach(r => {
            this.branchesList.push({ text: r.branch_name, value: r.branch_id })
          })
        })
    },

    closeDialog() {
      this.formData = {}
      this.$emit('close')
    },

    save() {
      // if (!this.formData.deliver_branch_id_fk) {
      //   this.inValid = true
      //   setTimeout(() => {
      //     this.inValid = false
      //   }, 2500)
      //   return
      // }

      let token = localStorage.getItem('access_token')

      axios
        .put(`api/approving_order/${this.orderId}`, this.formData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.$emit('resetTable')
          this.closeDialog()
          this.$emit('clicked')
          swal({
            title: this.$t('common.done'),
            text: this.$t('customer.approvedTitle'),
            icon: 'success',
            timer: 1500,
            buttons: false
          })
        })
        .catch((error) => {
          swal(this.$t('common.error'), error.response.data.message, 'error')
          // if (error.response.data.message === 'money') {
          //   swal(this.$t('common.error'), "You don't have enough money to approve this order", 'error')
          // } else {
          //   this.$emit('resetTable')
          //   this.closeDialog()
          //   this.$emit('clicked')
          //   swal({
          //     title: this.$t('common.done'),
          //     text: this.$t('customer.approvedTitle'),
          //     icon: 'success',
          //     timer: 1500,
          //     buttons: false
          //   })
          // }
        })
    }
  }
}
</script>

<style scoped>
.branch-description {
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/customer/approveOrder.vue